import * as Yup from 'yup';
import React from 'react';
import { Formik } from 'formik';
import { MdPeople } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

interface MaxCapacityModalProps {
  initialValues: { maxCapacity: number };
  onClose: () => void;
  onSave: (maxCapacity: number) => void;
}

const MaxCapacitySchema = Yup.object().shape({
  maxCapacity: Yup.string()
    .required('Required field')
    .matches(/^\d+$/, 'Must be a valid number')
    .test(
      'min',
      'must be greater than or equal to 1',
      (value) => !value || parseInt(value, 10) >= 1
    )
});

const MaxCapacityModal: React.FC<MaxCapacityModalProps> = ({
  initialValues,
  onClose,
  onSave
}) => (
  <Formik
    initialValues={{ maxCapacity: initialValues.maxCapacity.toString() }}
    onSubmit={(values) => {
      onSave(parseInt(values.maxCapacity, 10));
      onClose();
    }}
    enableReinitialize
    validationSchema={MaxCapacitySchema}
  >
    {({ submitForm }) => (
      <Modal
        type={ModalType.SMALL}
        onClose={onClose}
        autoHeight
        visible
        icon={<MdPeople size={20} />}
        title="Max capacity"
        renderFooter={() => (
          <Button type={ButtonType.Primary} onClick={submitForm}>
            Save max capacity
          </Button>
        )}
      >
        <div className="px-4 pt-6">
          <Field
            type="text"
            label="Capacity"
            id="maxCapacity"
            name="maxCapacity"
            clearable
            placeholder="e.g. 100"
          />
        </div>
      </Modal>
    )}
  </Formik>
);

export default MaxCapacityModal;
